<template>
  <div class="rodeDetail">
    <div class="title">
      返程推荐 <span>线路详情</span>
    </div>
    <div class="detail_info">
      <div class="info_title">线路详情</div>
      <el-button @click="handleBackClick">返回</el-button>
    </div>
    <div class="container">
      <el-table :data="data.returnGoodslist"
                style="width: 100%"
                class="table_main"
                height="100%">
        <el-table-column label="序号"
                         align="center"
                         type="index"
                         min-width="40">
        </el-table-column>
        <el-table-column prop="goodsNum"
                         label="货源编号"
                         min-width="85"
                         header-align="center"
                         align="left">
        </el-table-column>
        <el-table-column header-align="center"
                         align="left"
                         label="货主信息"
                         min-width="160">
          <template slot-scope="scope">
            <div><span>公司名称：</span>{{scope.row.userCompanyName}}</div>
            <div><span>联系人姓名：</span>{{scope.row.userCompanyLinkman}}</div>
            <div><span>联系电话：</span>{{scope.row.userCompanyIphone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="位置信息"
                         header-align="center"
                         align="left"
                         width="160">
          <template slot-scope="scope">
            <div><span>出发地：</span>{{scope.row.departLand}}{{scope.row.departLandDetails}}</div>
            <div><span>目的地：</span>{{scope.row.destina}}{{scope.row.destinaDetails}}</div>
          </template>
        </el-table-column>
        <el-table-column label="货源信息"
                         header-align="center"
                         align="left"
                         min-width="160">
          <template slot-scope="scope">
            <div><span>期望运费：</span>{{scope.row.expectFreight}}</div>
            <div><span>炼厂名称：</span>{{scope.row.refineryName}}</div>
            <div><span>原料：</span>{{scope.row.material}}</div>
            <div><span>重量：</span>{{scope.row.totalWeight}}吨</div>
            <div v-if="scope.row.tankBody==='0'"><span>罐体：</span>铝罐</div>
            <div v-if="scope.row.tankBody==='1'"><span>罐体：</span>铁罐</div>
            <div v-if="scope.row.tankBody==='2'"><span>罐体：</span>钢罐</div>
            <div v-if="scope.row.tankBody==='3'"><span>罐体：</span>铝合金</div>
            <div v-if="scope.row.tankBody==='4'"><span>罐体：</span>不限</div>
            <div><span>货源有效期：</span>{{scope.row.startTime}}至{{scope.row.endTime}}</div>
          </template>
        </el-table-column>
        <el-table-column label="招标详情"
                         header-align="center"
                         align="left"
                         min-width="110">
          <template slot-scope="scope">
            <div><span>已匹配重量：</span><span>{{scope.row.matchWeight}}</span>吨</div>
            <div><span>已匹配车辆：</span>{{scope.row.matchWeight}}辆</div>
            <div><span>已谈成重量：</span>{{scope.row.talkWeight}}吨</div>
            <div><span>已谈成车辆：</span>{{scope.row.talkVehicle}}辆</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         width="97">
          <template slot-scope="scope">
            <div v-if="scope.row.goodsType==='01'">待匹配</div>
            <div v-else-if="scope.row.goodsType==='02'">已匹配</div>
            <div v-else-if="scope.row.goodsType==='03'">已取消</div>
            <!-- <div v-else-if="scope.row.goodsType==='3'">已失效</div> -->
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         min-width="100"
                         align="center">
          <template slot-scope="scope">
            <el-button @click="matchingCars(scope.row)">匹配车辆</el-button>
            <!-- <el-button @click="matchingCars(scope.row)">匹配车辆</el-button> -->

          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="提示"
               :visible.sync="matchingCar"
               class="matchingCarTable">
      <div class="matchingCarDetail">
        <p>匹配车辆前请先确定信息是否选择正确</p>
        <div><span>车辆服务费(￥)：</span>
          <el-input size="small"
                    v-model="amount"></el-input> 辆/次
        </div>
        <p class="remarks">服务费设置金额为0—300元</p>
      </div>
      <div class="matchingBtn">
        <div>取消</div>
        <div @click="handleConfirmClick">确定</div>
      </div>
    </el-dialog>
    <!-- <div class="pages">
            <span class="demonstartion"> 共{{data.total}}条记录</span>
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="data.pageSize"
                layout="prev, pager, next"
                :total="data.total"
                background
            >
            </el-pagination>
        </div> -->
  </div>
</template>
<script>
import {
  proposedRodeDetail,
  matchCars
} from 'apis/index'
export default {
  data () {
    return {
      seniorGoodsId: '',
      driverId: '',
      expectFreight: '',
      driverPaySum: '',
      goodsNo: '',
      goodsIds: '',
      addressName: '',
      routes: '',
      departure: '',
      goodsAddressLatlng: '',
      data: {},
      amount: 0, // 服务费
      matchingCar: false
    }
  },
  methods: {
    handleBackClick () {
      this.$router.go(-1)
    },
    getData () { // 获取数据
      proposedRodeDetail({
        'driverId': this.driverId,
        'goodsIds': this.goodsIds,
        'routes': this.routes,
        'departure': this.departure
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.data = res.data.data
        }
      })
    },
    matchingCars (item) { // 匹配车辆
      this.seniorGoodsId = item.goodsId
      this.expectFreight = item.expectFreight
      this.addressName = item.departLand + ',' + item.departLandDetails
      //   console.log(
      //     'seniorGoodsId', this.seniorGoodsId,
      //     'driverId', this.data.driverId,
      //     'expectFreight', this.expectFreight,
      //     'driverPaySum', this.amount,
      //     'goodsNo', this.data.goodsNo,
      //     'goodsIds', this.data.goodsIds,
      //     'addressName', this.addressName,
      //     'routes', this.routes,
      //     'goodsAddressLatlng', this.goodsAddressLatlng
      //   )

      //   this.matchingCar = true
      if (this.data.roleType === '0') { // 0是物流公司。不收服务费
        this.$confirm('确认匹配信息无误?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          matchCars({
            'seniorGoodsId': this.seniorGoodsId,
            'driverId': this.data.driverId,
            'expectFreight': this.expectFreight,
            // 'driverPaySum': this.amount,
            'goodsNo': this.data.goodsNo,
            'goodsIds': this.data.goodsIds,
            'addressName': this.addressName,
            'routes': this.routes,
            'goodsAddressLatlng': this.goodsAddressLatlng
          }).then(res => {
            if (res.data.code === 0) {
              this.$router.push({ path: '/manage/recommend' })
            } else if (res.data.code === -1) {
              this.$confirm('该车辆已匹配过运单', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.push({ path: '/manage/recommend' })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消匹配'
                })
                this.$router.push({ path: '/manage/recommend' })
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消匹配'
          })
        })
      } else {
        this.matchingCar = true
      }
    },
    handleConfirmClick () { // 确认匹配
      matchCars({
        'seniorGoodsId': this.seniorGoodsId,
        'driverId': this.data.driverId,
        'expectFreight': this.expectFreight,
        'driverPaySum': this.amount,
        'goodsNo': this.data.goodsNo,
        'goodsIds': this.data.goodsIds,
        'addressName': this.addressName,
        'routes': this.routes,
        'goodsAddressLatlng': this.goodsAddressLatlng
      }).then(res => {
        if (res.data.code === 0) {
          this.$router.push({ path: '/manage/recommend' })
        } else if (res.data.code === -1) {
          this.$confirm('该车辆已匹配过运单', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({ path: '/manage/recommend' })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消匹配'
            })
            this.$router.push({ path: '/manage/recommend' })
          })
        }
      })
    },
    handleCurrentChange (val) { // 切页切换
      //   let pageNum = val
      //   console.log(status)
      //   if (status === '') {
      //     privatelist({pageNum: pageNum}).then(res => {
      //       this.data = res.data.data.result
      //     })
      //   } else {
      //     privatelist({
      //       pageNum: pageNum
      //     }).then(res => {
      //       this.data = res.data.data.result
      //     })
      //   }
    }
  },
  mounted () {
    this.driverId = this.$route.query.driverId
    this.goodsIds = this.$route.query.goodsIds
    this.routes = this.$route.query.routes
    this.departure = this.$route.query.departure
    this.goodsAddressLatlng = this.$route.query.goodsAddressLatlng
    if (this.driverId && this.goodsIds && this.routes && this.departure && this.goodsAddressLatlng) {
      this.getData()
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.rodeDetail
  height 100%
  .title
    padding-left 20px
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 77px #F7F9FB
    span
      color #212832
      margin-left 20px
  .detail_info
    width calc(100% - 40px)
    overflow hidden
    background #fff
    margin 0 auto
    .info_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../../assets/images/09/xq_icon.png') no-repeat center left 15px
      border-bottom 1px solid #CFD5DC
    .el-button
      float right
      padding 7px 26px
      background #fff
      color #1B88EE
      font-size 12px
      border 1px solid #1B88EE
      margin 10px 20px
  .container
    margin-left 20px
    margin-right 20px
    height calc(100% - 200px)
    overflow hidden
    .table_main
      overflow-y hidden
      background #f7f9fb
    .el-table
      th
        background #e7f0f8
      .cell
        size12()
      td
        .cell
          size12()
          .el-button
            padding 7px 14px
            background #1B88EE
            color #fff
            font-size 12px
            border 1px solid #1B88EE
    .el-table__header-wrapper
      background #e7f0f8
  .el-table td, .el-table th
    vertical-align top
  .matchingCarTable
    .el-dialog
      width 310px
      border-radius 5px
      overflow hidden
      top 20%
    .el-dialog__header
      height 42px
      padding 0 20px 0
      background #FFFFFF
      text-align center
      border-bottom 1px solid #CFD5DC
      .el-dialog__title
        line-height 42px
        font-size 13px
        color #858C96
        text-align center
      .el-dialog__headerbtn
        top 12px
        right 12px
      .el-dialog__close
        color #ADB4BE
        font-size 20px
    .el-dialog__body
      padding 0
      .matchingCarDetail
        padding 10px 10px
        p
          text-align center
          line-height 40px
        div
          font-size 13px
          padding-left 20px
          .el-input
            width 100px
            display inline-block
        .remarks
          font-size 12px
          color #f66
      .matchingBtn
        width 100%
        div
          width 50%
          height 34px
          display inline-block
          text-align center
          cursor pointer
          line-height 34px
          &:nth-child(1)
            background #F7F9FB
            color #858C96
          &:nth-child(2)
            background #1B88EE
            color #fff
  .pages
    padding 0 20px
    margin-top 15px
    margin-bottom 15px
    .demonstartion
      float right
      line-height 45px
      color #5e656f
</style>
